// components/FilterHeader.tsx
import React from 'react';
import { Link } from 'react-router-dom';

interface FilterHeaderProps {
    title: string; 
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    selectedSort: string;
    setSelectedSort: (sort: string) => void;
}

const StatusFilterHeader: React.FC<FilterHeaderProps> = ({
    title,
    selectedStatus,
    setSelectedStatus,
    selectedSort,
    setSelectedSort
}) => {
    return (
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>{title}</h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedStatus ? selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1) : "Select Status"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {["All", "active", "inactive"].map((status) => (
                            <li key={status}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedStatus(status)}
                                    className="dropdown-item rounded-1"
                                >
                                    {status.charAt(0).toUpperCase() + status.slice(1)}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="dropdown">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedSort ? `Sort By : ${selectedSort}` : "Sort By : Last 7 Days"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {["Recently Added", "Ascending", "Descending", "Last Month", "Last 7 Days"].map((sort) => (
                            <li key={sort}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedSort(sort)}
                                    className="dropdown-item rounded-1"
                                >
                                    {sort}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default StatusFilterHeader;
